import useDebounce from 'react-use/lib/useDebounce';

import type { ICompany, ISuggestion } from '../../../helpers/models';
import { getCompaniesSuggestions } from '../../../helpers/api/dadata-api';
import { transformResData } from '../actions';
import type { IOption } from '../models';

export const useFieldDebounce = (
    value: string,
    type: string,
    cb: (values: IOption[]) => void,
    delay: number,
    count: number,
    minLengthQuery: number
) =>
    useDebounce(
        async () => {
            if (value.length >= minLengthQuery) {
                let suggestions: ISuggestion[] = [];
                try {
                    ({ suggestions } = await getCompaniesSuggestions({
                        query: value,
                        count,
                    }));
                } catch (error) {
                    console.error(error);
                }

                const organizationsFilter = ({ data }: { data: ICompany }) =>
                    data.state.status === 'ACTIVE' && // действующая организвания
                    data.inn.slice(0, 4) !== '9909' && // только резиденты
                    ((data.type === 'LEGAL' && data.branch_type === 'MAIN') ||
                        data.type === 'INDIVIDUAL'); // головная организация или ИП

                const mappedSuggestions = suggestions
                    .filter(organizationsFilter)
                    .map(transformResData);

                cb(mappedSuggestions);
            } else {
                cb([]);
            }
        },
        delay,
        [value]
    );
